import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Loader from "../../components/Loader";
import RemoveIcon from "@material-ui/icons/Remove";
import { IconButton, Icon } from "@material-ui/core";
import Button from "components/CustomButtons/Button.js";
import Toaster from "components/Toaster";

import {
  MenuItem,
  FormControl,
  InputLabel,
  Grid,
  Select,
  Toolbar,
} from "@material-ui/core";

import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";

import {
  API_BASE_URL,
  EQUIPMENT_TYPE,
  ROLES as USER_ROLES,
} from "../../configs/constant";
import {
  VEHICLE,
  EQUIPMENT,
  USERS,
  CREATE_SUB_TEAM,
  EQUIPMENT_TYPE as EQUIPMENT_TYPE_URL,
} from "../../configs/urls";
import axios from "axios";
import { getApi, postApi } from "../../services/api";
import styles from "assets/jss/material-dashboard-react/components/headerStyle.js";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { Prompt, useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  formControl: {
    minWidth: "100%",
  },
  marginLeft: {
    marginLeft: "50% !important",
  },
  cardTitleWhite: {
    margin: 0,
    textTransform: "capitalize",
  },
  buttonContainer: {
    width: "100% !important",
  },
  disable: {
    pointerEvents: "none",
    opacity: 0.5,
  },
}));

const navBarStyles = makeStyles(styles);

export default function SubTeam(props) {
  const history = useHistory();
  const navBarClasses = navBarStyles();

  const [subTeamData, setSubTeamData] = useState({
    sub_teams: {},
  });

  const [vehiclesList, setVehiclesList] = useState([]);
  const [driverList, setDriverList] = useState([]);
  const [helperList, setHelperList] = useState([]);
  const [rakeEquipmentList, setRakeEquipmentList] = useState([]);
  const [bailerEquipmentList, setBailerEquipmentList] = useState([]);
  const [isRequesting, setIsRequesting] = useState(true);
  const [trolleyEquipementList, setTrolleyEquipementList] = useState([]);
  const [equipmentTypes, setEquipmentTypeList] = useState([]);
  // const [selectedTeam, setSelectedTeam] = useState([]);
  const [teamTypes, setTeamTypes] = useState([]);
  const [params, setParams] = useState({ page: 0 });
  const [trolleyEquipmentListList, setTrolleyEquipmentListList] = useState([]);
  const [uprooterEquipmentListList, setUpRooterEquipmentListList] = useState(
    []
  );
  const [equipmentsList, setEquipmentsList] = useState([]);
  const [equipmentsData, setEquipmentsData] = useState([]);
  const [equipmentsListToShow, setEquipmentsListToShow] = useState([]);
  const [selectedTeam, setTeamSelect] = useState("");
  const [showPrompt, setShowPrompt] = useState(false);

  const [fixedEquipmentList, setFixedEquipmentList] = useState([
    {
      id: 2,
      name: "Rake",
      fixed: 1,
      active: 1,
      driver_id: "",
      equipment_id: 2,
      vehicle_id: "",
      equipmentType: 2,
    },
    {
      id: 3,
      name: "Cutter",
      fixed: 1,
      active: 1,
      driver_id: "",
      equipment_id: 3,
      vehicle_id: "",
      equipmentType: 3,
    },
    {
      id: 4,
      name: "Bailer",
      fixed: 1,
      active: 1,
      driver_id: "",
      equipment_id: 4,
      vehicle_id: "",
      equipmentType: 4,
    },
    {
      id: 1,
      name: "Trolley",
      fixed: 1,
      active: 1,
      driver_id: "",
      equipment_id: 1,
      vehicle_id: "",
      equipmentType: 1,
    },
    {
      id: 9,
      name: "Swatch",
      fixed: 0,
      active: 1,
      driver_id: "",
      equipment_id: 9,
      vehicle_id: "",
      equipmentType: 9,
    },
    {
      id: 8,
      name: "Conditioner",
      fixed: 0,
      active: 1,
      driver_id: "",
      equipment_id: 8,
      vehicle_id: "",
      equipmentType: 8,
    },
    {
      id: 39,
      name: "Uprooter",
      fixed: 0,
      active: 1,
      driver_id: "",
      equipment_id: 39,
      vehicle_id: "",
      equipmentType: 39,
    },
  ]);

  useEffect(() => {
    fetchEquipmentTypes(true);
  }, []); //eslint-disable-line

  const fetchEquipmentTypes = (isInitialLoad) => {
    setIsRequesting(true);

    getApi(EQUIPMENT_TYPE_URL, params)
      .then(
        (res) => {
          const data = res.data || [];
          const newList = [...equipmentTypes, ...data];
          setEquipmentTypeList(newList);
          const tempTeamTypes = newList.map((item) =>
            `${item.name?.toLowerCase()}Team`.replace(/ /g, "")
          );
          setTeamTypes(tempTeamTypes);
        },
        (err) => {
          console.log(err);
        }
      )
      .finally(() => {
        setIsRequesting(false);
      });
  };

  /**
   * @description Fetching equipment list
   */
  useEffect(() => {
    axios.get(`${API_BASE_URL}/equipment`).then(({ data = [] }) => {
      const types = data.map(({ type = {}, equipment_type }) => {
        return {
          ...type,
          driver_id: "",
          equipment_id: type.id,
          vehicle_id: "",
          equipmentType: equipment_type,
        };
      });
      setEquipmentsData(data);
      setEquipmentsListToShow(types);
    });
  }, []);

  useEffect(() => {
    const getVehicles = getApi(VEHICLE, { district_id: 1 });
    const getDrivers = getApi(USERS, { role: USER_ROLES.DRIVER });
    const getHelpers = getApi(USERS, { role: USER_ROLES.HELPER });
    const getAllEquipments = getApi(EQUIPMENT);
    const rakeEquipments = getApi(EQUIPMENT, {
      equipment_type: EQUIPMENT_TYPE.RAKE,
    });
    const bailerEquipments = getApi(EQUIPMENT, {
      equipment_type: EQUIPMENT_TYPE.BAILER,
    });
    const trolleyEquipments = getApi(EQUIPMENT, {
      equipment_type: EQUIPMENT_TYPE.TROLLEY,
    });
    const uprooterEquipments = getApi(EQUIPMENT, {
      equipment_type: EQUIPMENT_TYPE.UPROOTER,
    });

    axios
      .all([
        getVehicles,
        getDrivers,
        rakeEquipments,
        bailerEquipments,
        trolleyEquipments,
        uprooterEquipments,
        getHelpers,
        getAllEquipments,
      ])
      .then((res) => {
        if (res[0] && res[0].data) {
          setVehiclesList(res[0].data);
        }

        if (res[1] && res[1].data) {
          setDriverList(res[1].data);
        }

        if (res[2] && res[2].data) {
          setRakeEquipmentList(res[2].data);
        }

        if (res[3] && res[3].data) {
          setBailerEquipmentList(res[3].data);
        }

        if (res[4] && res[4].data) {
          setTrolleyEquipmentListList(res[4].data);
        }

        if (res[5] && res[5].data) {
          setHelperList(res[5].data);
        }
        if (res[6] && res[6].data) {
          setUpRooterEquipmentListList(res[6]?.data);
        }

        setRequiredData();
      })
      .finally(() => {
        setIsRequesting(false);
      });
  }, [equipmentTypes]);

  const setRequiredData = () => {
    const teamTypes = ["rake", "bailer", "trolley"];
    const subTeamsList = {};

    equipmentTypes &&
      equipmentTypes.map((type) => {
        if (props.team && props.team.sub_teams)
          props.team.sub_teams.map((team) => {
            const teamType = type?.name?.toLowerCase().replace(/ /g, "");
            if (teamType == team?.team_type?.toLowerCase()) {
              team.isAlreadyPresent = true;
              if (!subTeamsList[teamType]) {
                subTeamsList[teamType] = [team];
              } else {
                subTeamsList[teamType].push(team);
              }
            }
          });
      });

    const updatedSubTeams = {};
    Object.keys(subTeamsList).map((teamKey) => {
      updatedSubTeams[`${teamKey}Team`] = subTeamsList[teamKey] || [];
    });
    const data = {
      sub_teams: { ...updatedSubTeams },
    };
    setTimeout(() => {
      setSubTeamData({ ...data });
    }, 1000);
  };

  const getSelectableDrivers = (type) => {
    let subTeamDataForUpdate = { ...subTeamData };
    const teamTypes = Object.keys(subTeamDataForUpdate.sub_teams);
    let selectedDrivers = [];
    teamTypes &&
      teamTypes.map((t) => {
        if (t != type) {
          const subTeamFilterData =
            subTeamDataForUpdate.sub_teams[t]
              ?.map((st) => st.driver_id)
              ?.filter((val) => val) || [];
          selectedDrivers = [...selectedDrivers, ...subTeamFilterData];
        }
      });
    return driverList.filter((d) => !selectedDrivers.includes(d.id));
  };

  const getSelectableEquipments = (type) => {
    let subTeamDataForUpdate = { ...subTeamData };
    const teamTypes = Object.keys(subTeamDataForUpdate.sub_teams);
    let selectedEquipments = [];
    teamTypes &&
      teamTypes.map((t) => {
        if (type && t != type) {
          const subTeamFilterData =
            subTeamDataForUpdate.sub_teams[t]
              ?.map((st) => st.equipment_id)
              ?.filter((val) => val) || [];
          selectedEquipments = [...selectedEquipments, ...subTeamFilterData];
        }
      });

    let eqListForParticularType = [];
    if (type) {
      eqListForParticularType = equipmentsData.filter((equipment) => {
        if (
          equipment &&
          equipment.type &&
          equipment.type.name?.toLowerCase() ==
            type?.replace(/Team/i, "")?.toLowerCase()
        ) {
          return true;
        }
        if (
          equipment &&
          equipment.type &&
          equipment.type.name?.toLowerCase() == "up rooter"
        ) {
          return true;
        }
      });
    }

    return eqListForParticularType.filter(
      (d) => !selectedEquipments.includes(d.id)
    );
  };

  const getSelectableHelpers = (type) => {
    let subTeamDataForUpdate = { ...subTeamData };
    const teamTypes = Object.keys(subTeamDataForUpdate.sub_teams);
    let selectedHelpers = [];
    teamTypes &&
      teamTypes.map((t) => {
        if (t != type) {
          const subTeamFilterData =
            subTeamDataForUpdate.sub_teams[t]
              ?.map((st) => st.helper_id)
              ?.filter((val) => val) || [];
          selectedHelpers = [...selectedHelpers, ...subTeamFilterData];
        }
      });
    return helperList.filter((d) => !selectedHelpers.includes(d.id));
  };

  const getSelectableVehicles = (type) => {
    let subTeamDataForUpdate = { ...subTeamData };
    const teamTypes = Object.keys(subTeamDataForUpdate.sub_teams);
    let selectedVehicles = [];
    teamTypes.map((t) => {
      if (t != type) {
        selectedVehicles = [
          ...selectedVehicles,
          ...subTeamDataForUpdate.sub_teams[t]
            .map((st) => st.vehicle_id)
            .filter((val) => val),
        ];
      }
    });
    return vehiclesList.filter((d) => !selectedVehicles.includes(d.id));
  };

  const addOrRemoveTeamItem = (action, idx, teamType) => {
    let subTeamDataForUpdate = { ...subTeamData };
    if (action == "add") {
      subTeamDataForUpdate.sub_teams[teamType].push({
        driver_id: "",
        equipment_id: "",
        vehicle_id: "",
      });
    } else {
      subTeamDataForUpdate.sub_teams[teamType].splice(idx, 1);
    }

    setSubTeamData(subTeamDataForUpdate);
  };
  const addOrRemoveRakeTeam = (action, idx) => {
    let subTeamDataForUpdate = { ...subTeamData };
    if (action == "add") {
      setEquipmentsList([
        ...equipmentsList,
        {
          driver_id: "",
          equipment_id: "",
          vehicle_id: "",
        },
      ]);
    } else {
      equipmentsList.splice(idx, 1);
    }

    setSubTeamData(subTeamDataForUpdate);
  };

  const addOrRemoveBailerTeam = (action, idx) => {
    let subTeamDataForUpdate = { ...subTeamData };
    if (action == "add") {
      subTeamDataForUpdate.sub_teams.bailerTeam.push({
        driver_id: "",
        equipment_id: "",
        vehicle_id: "",
      });
    } else {
      subTeamDataForUpdate.sub_teams.bailerTeam.splice(idx, 1);
    }

    if (!subTeamDataForUpdate.sub_teams.bailerTeam.length) {
      subTeamDataForUpdate.sub_teams.trolleyTeam = [];
    }

    setSubTeamData(subTeamDataForUpdate);
  };

  const addOrRemoveTrolleyTeam = (action, idx) => {
    let subTeamDataForUpdate = { ...subTeamData };
    if (action == "add") {
      subTeamDataForUpdate.sub_teams.trolleyTeam.push({
        driver_id: "",
        equipment_id: "",
        vehicle_id: "",
      });
    } else {
      subTeamDataForUpdate.sub_teams.trolleyTeam.splice(idx, 1);
    }

    setSubTeamData(subTeamDataForUpdate);
  };

  const handleTeamFieldChange = (e, type, idx, key) => {
    let subTeamDataForUpdate = { ...subTeamData };

    let item = { ...subTeamDataForUpdate.sub_teams[type][idx] };

    item[key] = e.target.value;

    subTeamDataForUpdate.sub_teams[type][idx] = item;

    setSubTeamData(subTeamDataForUpdate);
  };

  const createSubTeam = () => {
    let isError = false;
    var data = {
      team_id: props.team.id,
    };

    var subTeams = [];
    const teamKeyList = Object.keys(subTeamData.sub_teams);
    for (
      let teamKeyIndex = 0;
      teamKeyIndex < teamKeyList.length;
      teamKeyIndex++
    ) {
      let teamType = teamKeyList[teamKeyIndex];
      if (
        subTeamData.sub_teams[teamType] &&
        subTeamData.sub_teams[teamType].length
      ) {
        for (
          let index = 0;
          index < subTeamData.sub_teams[teamType].length;
          index++
        ) {
          const teamData = subTeamData.sub_teams[teamType][index];
          if (
            teamData.driver_id &&
            teamData.equipment_id &&
            teamData.vehicle_id
          ) {
            isError = false;
            subTeams.push({
              team_type: teamType?.replace(/Team/i, "")?.toLowerCase(),
              ...teamData,
            });
          } else {
            isError = true;
            Toaster.showError(
              `Please fill ${teamType?.replace(/Team/i, "")} team field`
            );
            return;
          }
        }
      }
    }

    subTeams = subTeams.map((subTeam, index) => {
      const { queue_id = null } = subTeam;
      if (!queue_id) {
        let queueId = index + 1;
        const ind = subTeams.findIndex((item) => item?.queue_id === queueId);
        if (ind > -1) {
          queueId = subTeams[ind]?.queue_id + 1;
          subTeam["queue_id"] = queueId;
        } else {
          subTeam["queue_id"] = queueId;
        }
      }
      return subTeam;
    });
    subTeams = subTeams.filter((team) => !team.isAlreadyPresent);

    data.sub_teams = subTeams;

    if (!isError) {
      setIsRequesting(true);
      postApi(CREATE_SUB_TEAM, data)
        .then(
          (res) => {
            // props.closeDrawer("sub_team_added");
            history.push("/#/admin/jobs");
          },
          (err) => {
            console.error(err);
          }
        )
        .finally(() => {
          setIsRequesting(false);
        });
    }
  };

  /**
   * @description Handling data on click on Drop down
   *
   * @param {Number} id
   * @param {String} name
   * @returns
   */
  const handleEquipment = (id, name) => (_) => {
    setTeamSelect(name);
    const tempSubTeamData = { ...subTeamData };
    if (Boolean(name) && id) {
      const teamType = `${name?.toLowerCase()?.replace(/ /g, "")}Team`;
      const sub_teams = tempSubTeamData.sub_teams[teamType] || null;
      if (sub_teams) {
        sub_teams.push({
          driver_id: "",
          equipment_id: "",
          vehicle_id: "",
        });
      } else {
        tempSubTeamData.sub_teams[teamType] = [
          {
            driver_id: "",
            equipment_id: "",
            vehicle_id: "",
          },
        ];
      }
      const combinList =
        equipmentsList && equipmentsList.length
          ? [...equipmentsList, ...tempSubTeamData?.sub_teams[teamType]]
          : [...tempSubTeamData?.sub_teams[teamType]];
      setEquipmentsList([...combinList]);
    }
    if (Boolean(name) && !id) setEquipmentsList(equipmentsList);
  };

  const classes = useStyles();
  return (
    <>
      <div>
        <Loader isLoading={isRequesting} />
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Toolbar className={""}>
              <GridContainer
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <GridItem xs={12} sm={12} md={4}>
                  <Grid
                    container
                    direction="row"
                    justify="flex-start"
                    alignItems="center"
                  >
                    <Button
                      color="transparent"
                      onClick={() => {
                        props.closeDrawer();
                      }}
                      className={classes.title}
                      startIcon={<ArrowBackIosIcon />}
                    >
                      Go Back
                    </Button>
                  </Grid>
                </GridItem>
                {/* {!subTeamData.sub_teams.rakeTeam.length && (
                <GridItem xs={12} sm={12} md={4}>
                  <Button
                    color="primary"
                    onClick={() => {
                      addOrRemoveRakeTeam("add");
                    }}
                  >
                    Show Rake team
                  </Button>
                </GridItem>
              )}
              {!subTeamData.sub_teams.bailerTeam.length && (
                <GridItem xs={12} sm={12} md={4}>
                  <Button
                    color="primary"
                    onClick={() => {
                      addOrRemoveBailerTeam("add");
                    }}
                  >
                    Show Bailer Team
                  </Button>
                </GridItem>
              )}

              {subTeamData.sub_teams.bailerTeam.length > 0 &&
                !subTeamData.sub_teams.trolleyTeam.length && (
                  <GridItem xs={12} sm={12} md={4}>
                    <Button
                      color="primary"
                      onClick={() => {
                        addOrRemoveTrolleyTeam("add");
                      }}
                    >
                      Show Trolley Team
                    </Button>
                  </GridItem>
                )} */}

                <GridItem xs={12} sm={12} md={4} lg={4}>
                  <FormControl
                    variant="outlined"
                    className={`${classes.formControl}`}
                  >
                    <InputLabel id={"Select-Team"}>Select</InputLabel>

                    <Select
                      labelId={"Select-Team"}
                      id={"team-id"}
                      value={selectedTeam || ""}
                      // onChange={handleEquipment}
                      name="team_id"
                      label="Team"
                    >
                      {fixedEquipmentList.map(
                        (
                          { name = "", id = 0, equipment_id: equipmentId = "" },
                          idx
                        ) => {
                          return (
                            <MenuItem
                              key={idx + "-" + name + "-" + id}
                              value={name}
                              onClick={handleEquipment(equipmentId, name)}
                            >
                              {name} Team
                            </MenuItem>
                          );
                        }
                      )}
                    </Select>
                  </FormControl>
                </GridItem>
              </GridContainer>
            </Toolbar>
          </GridItem>

          {/* --- Placeholder when no team is selected--- */}
          {Boolean(!selectedTeam) && (
            <GridItem xs={12} sm={12} md={12}>
              <Card>
                <CardHeader color="primary">
                  <h4 className={classes.cardTitleWhite}>
                    No Team is selected yet
                  </h4>
                </CardHeader>
              </Card>
              <CardBody>
                <div className="sub-team-body" key={"idx"}>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={3}>
                      <Grid>
                        <FormControl
                          variant="outlined"
                          className={`${classes.formControl} ${classes.disable}`}
                        >
                          <InputLabel id={"rake-label-"}>
                            EquipmentList
                          </InputLabel>
                          <Select
                            labelId={"rake-label"}
                            id={"rake-id"}
                            name="equipment_id"
                            value={""}
                            label="EquipmentList"
                          >
                            <MenuItem key={"idx"} value={""}></MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={3}>
                      <Grid>
                        <FormControl
                          variant="outlined"
                          className={`${classes.formControl} ${classes.disable}`}
                        >
                          <InputLabel id={"vehicle-label"}>Vehicle</InputLabel>
                          <Select
                            labelId={"vehicle-label"}
                            id={"vehicle-id"}
                            value={""}
                            name="vehicle_id"
                            label="Vehicle"
                          >
                            <MenuItem key={"idx"} value={""}></MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={3}>
                      <Grid>
                        <FormControl
                          variant="outlined"
                          className={`${classes.formControl} ${classes.disable}`}
                        >
                          <InputLabel id={"driver-label"}>Driver</InputLabel>
                          <Select
                            labelId={"driver-label"}
                            id={"driver-id"}
                            value={""}
                            name="driver_id"
                            label="Driver"
                          >
                            <MenuItem key={"idx"} value={""}></MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                    </GridItem>
                  </GridContainer>
                </div>
              </CardBody>
            </GridItem>
          )}

          {/* {selectedTeam && equipmentsList.length > 0 && (
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              {equipmentsList.length > 0 &&
                equipmentsList.map(({ team_type = "" }, index) => {
                  if (index >= 1) return;
                  return (
                    <CardHeader color="primary">
                      <h4 className={classes.cardTitleWhite}>
                        {team_type[0].toUpperCase() + team_type.substring(1)}{" "}
                        Team
                      </h4>
                    </CardHeader>
                  );
                })}
              <CardBody>
                {equipmentsList.length > 0 &&
                  equipmentsList.map((rakeTeam, idx) => {
                    return (
                      <div className="sub-team-body" key={idx}>
                        <GridContainer>
                          <GridItem xs={12} sm={12} md={3}>
                            <Grid>
                              <FormControl
                                variant="outlined"
                                className={`${classes.formControl} ${
                                  rakeTeam.isAlreadyPresent
                                    ? classes.disable
                                    : ""
                                }`}
                              >
                                <InputLabel id={"rake-label-" + idx}>
                                  EquipmentList
                                </InputLabel>
                                <Select
                                  labelId={"rake-label" + idx}
                                  id={"rake-id" + idx}
                                  name="equipment_id"
                                  value={rakeTeam.equipment_id || ""}
                                  onChange={(event) =>
                                    handleTeamFieldChange(
                                      event,
                                      "rakeTeam",
                                      idx,
                                      "equipment_id"
                                    )
                                  }
                                  label="EquipmentList"
                                >
                                  {getSelectableEquipments("rakeTeam").map(
                                    (equipmentList, idx) => (
                                      <MenuItem
                                        key={idx}
                                        value={equipmentList.id}
                                      >
                                        {equipmentList.product_name} (
                                        {equipmentList.unique_number})
                                      </MenuItem>
                                    )
                                  )}
                                </Select>
                              </FormControl>
                            </Grid>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={3}>
                            <Grid>
                              <FormControl
                                variant="outlined"
                                className={`${classes.formControl} ${
                                  rakeTeam.isAlreadyPresent
                                    ? classes.disable
                                    : ""
                                }`}
                              >
                                <InputLabel id={"vehicle-label" + idx}>
                                  Vehicle
                                </InputLabel>
                                <Select
                                  labelId={"vehicle-label" + idx}
                                  id={"vehicle-id" + idx}
                                  value={rakeTeam.vehicle_id || ""}
                                  onChange={(event) =>
                                    handleTeamFieldChange(
                                      event,
                                      "rakeTeam",
                                      idx,
                                      "vehicle_id"
                                    )
                                  }
                                  name="vehicle_id"
                                  label="Vehicle"
                                >
                                  {getSelectableVehicles("rakeTeam").map(
                                    (vehicle, idx) => (
                                      <MenuItem key={idx} value={vehicle.id}>
                                        {`${vehicle.registration_number} (${vehicle.unique_number})`}
                                      </MenuItem>
                                    )
                                  )}
                                </Select>
                              </FormControl>
                            </Grid>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={3}>
                            <Grid>
                              <FormControl
                                variant="outlined"
                                className={`${classes.formControl} ${
                                  rakeTeam.isAlreadyPresent
                                    ? classes.disable
                                    : ""
                                }`}
                              >
                                <InputLabel id={"driver-label" + idx}>
                                  Driver
                                </InputLabel>
                                <Select
                                  labelId={"driver-label" + idx}
                                  id={"driver-id" + idx}
                                  value={rakeTeam.driver_id || ""}
                                  onChange={(event) =>
                                    handleTeamFieldChange(
                                      event,
                                      "rakeTeam",
                                      idx,
                                      "driver_id"
                                    )
                                  }
                                  name="driver_id"
                                  label="Driver"
                                >
                                  {getSelectableDrivers("rakeTeam").map(
                                    (driver, idx) => (
                                      <MenuItem key={idx} value={driver.id}>
                                        {driver.name}
                                      </MenuItem>
                                    )
                                  )}
                                </Select>
                              </FormControl>
                            </Grid>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={1}>
                            <Grid
                              container
                              direction="row"
                              justify="flex-end"
                              alignItems="center"
                            >
                              {equipmentsList.length == idx + 1 &&
                                equipmentsList.length != 10 && (
                                  <>
                                    <IconButton
                                      edge="end"
                                      aria-label="delete"
                                      className={`${
                                        rakeTeam.isAlreadyPresent
                                          ? classes.disable
                                          : ""
                                      }`}
                                      onClick={() =>
                                        addOrRemoveRakeTeam("remove", idx)
                                      }
                                    >
                                      <RemoveIcon />
                                    </IconButton>
                                    <IconButton
                                      edge="end"
                                      aria-label="delete"
                                      onClick={() =>
                                        addOrRemoveRakeTeam("add", idx)
                                      }
                                    >
                                      <Icon>add_circle</Icon>
                                    </IconButton>
                                  </>
                                )}
                              {(equipmentsList.length != idx + 1 ||
                                equipmentsList.length == 10) && (
                                <IconButton
                                  edge="end"
                                  className={`${
                                    rakeTeam.isAlreadyPresent
                                      ? classes.disable
                                      : ""
                                  }`}
                                  aria-label="delete"
                                  onClick={() =>
                                    addOrRemoveRakeTeam("remove", idx)
                                  }
                                >
                                  <RemoveIcon />
                                </IconButton>
                              )}
                            </Grid>
                          </GridItem>
                        </GridContainer>
                      </div>
                    );
                  })}
              </CardBody>
            </Card>
          </GridItem>
        )} */}

          {/* {subTeamData.sub_teams.rakeTeam.length > 0 && (
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="primary">
                <h4 className={classes.cardTitleWhite}>Rake Team</h4>
              </CardHeader>
              <CardBody>
                {subTeamData.sub_teams.rakeTeam.map((rakeTeam, idx) => {
                  return (
                    <div className="sub-team-body" key={idx}>
                      <GridContainer>
                        <GridItem xs={12} sm={12} md={3}>
                          <Grid>
                            <FormControl
                              variant="outlined"
                              className={`${classes.formControl} ${
                                rakeTeam.isAlreadyPresent ? classes.disable : ""
                              }`}
                            >
                              <InputLabel id={"rake-label-" + idx}>
                                EquipmentList
                              </InputLabel>
                              <Select
                                labelId={"rake-label" + idx}
                                id={"rake-id" + idx}
                                name="equipment_id"
                                value={rakeTeam.equipment_id || ""}
                                onChange={(event) =>
                                  handleTeamFieldChange(
                                    event,
                                    "rakeTeam",
                                    idx,
                                    "equipment_id"
                                  )
                                }
                                label="EquipmentList"
                              >
                                {getSelectableEquipments("rakeTeam").map(
                                  (equipmentList, idx) => (
                                    <MenuItem
                                      key={idx}
                                      value={equipmentList.id}
                                    >
                                      {equipmentList.product_name} (
                                      {equipmentList.unique_number})
                                    </MenuItem>
                                  )
                                )}
                              </Select>
                            </FormControl>
                          </Grid>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={3}>
                          <Grid>
                            <FormControl
                              variant="outlined"
                              className={`${classes.formControl} ${
                                rakeTeam.isAlreadyPresent ? classes.disable : ""
                              }`}
                            >
                              <InputLabel id={"vehicle-label" + idx}>
                                Vehicle
                              </InputLabel>
                              <Select
                                labelId={"vehicle-label" + idx}
                                id={"vehicle-id" + idx}
                                value={rakeTeam.vehicle_id || ""}
                                onChange={(event) =>
                                  handleTeamFieldChange(
                                    event,
                                    "rakeTeam",
                                    idx,
                                    "vehicle_id"
                                  )
                                }
                                name="vehicle_id"
                                label="Vehicle"
                              >
                                {getSelectableVehicles("rakeTeam").map(
                                  (vehicle, idx) => (
                                    <MenuItem key={idx} value={vehicle.id}>
                                      {`${vehicle.registration_number} (${vehicle.unique_number})`}
                                    </MenuItem>
                                  )
                                )}
                              </Select>
                            </FormControl>
                          </Grid>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={3}>
                          <Grid>
                            <FormControl
                              variant="outlined"
                              className={`${classes.formControl} ${
                                rakeTeam.isAlreadyPresent ? classes.disable : ""
                              }`}
                            >
                              <InputLabel id={"driver-label" + idx}>
                                Driver
                              </InputLabel>
                              <Select
                                labelId={"driver-label" + idx}
                                id={"driver-id" + idx}
                                value={rakeTeam.driver_id || ""}
                                onChange={(event) =>
                                  handleTeamFieldChange(
                                    event,
                                    "rakeTeam",
                                    idx,
                                    "driver_id"
                                  )
                                }
                                name="driver_id"
                                label="Driver"
                              >
                                {getSelectableDrivers("rakeTeam").map(
                                  (driver, idx) => (
                                    <MenuItem key={idx} value={driver.id}>
                                      {driver.name}
                                    </MenuItem>
                                  )
                                )}
                              </Select>
                            </FormControl>
                          </Grid>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={1}>
                          <Grid
                            container
                            direction="row"
                            justify="flex-end"
                            alignItems="center"
                          >
                            {subTeamData.sub_teams.rakeTeam.length == idx + 1 &&
                              subTeamData.sub_teams.rakeTeam.length != 10 && (
                                <>
                                  <IconButton
                                    edge="end"
                                    aria-label="delete"
                                    className={`${
                                      rakeTeam.isAlreadyPresent
                                        ? classes.disable
                                        : ""
                                    }`}
                                    onClick={() =>
                                      addOrRemoveRakeTeam("remove", idx)
                                    }
                                  >
                                    <RemoveIcon />
                                  </IconButton>
                                  <IconButton
                                    edge="end"
                                    aria-label="delete"
                                    onClick={() =>
                                      addOrRemoveRakeTeam("add", idx)
                                    }
                                  >
                                    <Icon>add_circle</Icon>
                                  </IconButton>
                                </>
                              )}
                            {(subTeamData.sub_teams.rakeTeam.length !=
                              idx + 1 ||
                              subTeamData.sub_teams.rakeTeam.length == 10) && (
                              <IconButton
                                edge="end"
                                className={`${
                                  rakeTeam.isAlreadyPresent
                                    ? classes.disable
                                    : ""
                                }`}
                                aria-label="delete"
                                onClick={() =>
                                  addOrRemoveRakeTeam("remove", idx)
                                }
                              >
                                <RemoveIcon />
                              </IconButton>
                            )}
                          </Grid>
                        </GridItem>
                      </GridContainer>
                    </div>
                  );
                })}
              </CardBody>
            </Card>
          </GridItem>
        )} */}

          {/* {selectedTeam && subTeamData.sub_teams.bailerTeam.length > 0 && (
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="primary">
                <h4 className={classes.cardTitleWhite}>Bailer Team</h4>
              </CardHeader>
              <CardBody>
                {subTeamData.sub_teams.bailerTeam.map((bailerTeam, idx) => {
                  return (
                    <div className="sub-team-body" key={idx}>
                      <GridContainer>
                        <GridItem xs={12} sm={12} md={3}>
                          <Grid>
                            <FormControl
                              variant="outlined"
                              className={`${classes.formControl} ${
                                bailerTeam.isAlreadyPresent
                                  ? classes.disable
                                  : ""
                              }`}
                            >
                              <InputLabel id={"rake-label-" + idx}>
                                EquipmentList
                              </InputLabel>
                              <Select
                                labelId={"rake-label" + idx}
                                id={"rake-id" + idx}
                                name="equipment_id"
                                value={bailerTeam.equipment_id || ""}
                                onChange={(event) =>
                                  handleTeamFieldChange(
                                    event,
                                    "bailerTeam",
                                    idx,
                                    "equipment_id"
                                  )
                                }
                                label="EquipmentList"
                              >
                                {getSelectableEquipments("bailerTeam").map(
                                  (equipmentList, idx) => (
                                    <MenuItem
                                      key={idx}
                                      value={equipmentList.id}
                                    >
                                      {equipmentList.product_name} (
                                      {equipmentList.unique_number})
                                    </MenuItem>
                                  )
                                )}
                              </Select>
                            </FormControl>
                          </Grid>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={3}>
                          <Grid>
                            <FormControl
                              variant="outlined"
                              className={`${classes.formControl} ${
                                bailerTeam.isAlreadyPresent
                                  ? classes.disable
                                  : ""
                              }`}
                            >
                              <InputLabel id={"vehicle-label" + idx}>
                                Vehicle
                              </InputLabel>
                              <Select
                                labelId={"vehicle-label" + idx}
                                id={"vehicle-id" + idx}
                                value={bailerTeam.vehicle_id || ""}
                                onChange={(event) =>
                                  handleTeamFieldChange(
                                    event,
                                    "bailerTeam",
                                    idx,
                                    "vehicle_id"
                                  )
                                }
                                name="vehicle_id"
                                label="Vehicle"
                              >
                                {getSelectableVehicles("bailerTeam").map(
                                  (vehicle, idx) => (
                                    <MenuItem key={idx} value={vehicle.id}>
                                      {`${vehicle.registration_number} (${vehicle.unique_number})`}
                                    </MenuItem>
                                  )
                                )}
                              </Select>
                            </FormControl>
                          </Grid>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={3}>
                          <Grid>
                            <FormControl
                              variant="outlined"
                              className={`${classes.formControl} ${
                                bailerTeam.isAlreadyPresent
                                  ? classes.disable
                                  : ""
                              }`}
                            >
                              <InputLabel id={"driver-label" + idx}>
                                Driver
                              </InputLabel>
                              <Select
                                labelId={"driver-label" + idx}
                                onChange={(event) =>
                                  handleTeamFieldChange(
                                    event,
                                    "bailerTeam",
                                    idx,
                                    "driver_id"
                                  )
                                }
                                id={"driver-id" + idx}
                                value={bailerTeam.driver_id || ""}
                                name="driver_id"
                                label="Driver"
                              >
                                {getSelectableDrivers("bailerTeam").map(
                                  (driver, idx) => (
                                    <MenuItem key={idx} value={driver.id}>
                                      {driver.name}
                                    </MenuItem>
                                  )
                                )}
                              </Select>
                            </FormControl>
                          </Grid>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={2}>
                          <Grid>
                            <FormControl
                              variant="outlined"
                              className={`${classes.formControl} ${
                                bailerTeam.isAlreadyPresent
                                  ? classes.disable
                                  : ""
                              }`}
                            >
                              <InputLabel id={"helper-label" + idx}>
                                Helper
                              </InputLabel>
                              <Select
                                labelId={"helper-label" + idx}
                                id={"helper-id" + idx}
                                value={bailerTeam.helper_id || ""}
                                onChange={(event) =>
                                  handleTeamFieldChange(
                                    event,
                                    "bailerTeam",
                                    idx,
                                    "helper_id"
                                  )
                                }
                                name="helper_id"
                                label="Helper"
                              >
                                {getSelectableHelpers("bailerTeam").map(
                                  (helper, idx) => (
                                    <MenuItem key={idx} value={helper.id}>
                                      {helper.name}
                                    </MenuItem>
                                  )
                                )}
                              </Select>
                            </FormControl>
                          </Grid>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={1}>
                          <Grid
                            container
                            direction="row"
                            justify="flex-end"
                            alignItems="center"
                          >
                            <IconButton
                              edge="end"
                              aria-label="delete"
                              className={`${
                                bailerTeam.isAlreadyPresent
                                  ? classes.disable
                                  : ""
                              }`}
                              onClick={() =>
                                addOrRemoveBailerTeam("remove", idx)
                              }
                            >
                              <RemoveIcon />
                            </IconButton>
                            {subTeamData.sub_teams.bailerTeam.length ==
                              idx + 1 && (
                              <IconButton
                                edge="end"
                                aria-label="delete"
                                onClick={() =>
                                  addOrRemoveBailerTeam("add", idx)
                                }
                              >
                                <Icon>add_circle</Icon>
                              </IconButton>
                            )}
                          </Grid>
                        </GridItem>
                      </GridContainer>
                    </div>
                  );
                })}
              </CardBody>
            </Card>
          </GridItem>
        )} */}
          {selectedTeam &&
            Object.keys(subTeamData.sub_teams).map((teamType) => {
              return (
                subTeamData.sub_teams[teamType].length > 0 && (
                  <GridItem
                    xs={12}
                    sm={12}
                    md={12}
                    key={`${new Date()}-${teamType}`}
                  >
                    <Card>
                      <CardHeader color="primary">
                        <h4 className={classes.cardTitleWhite}>
                          {teamType.replace(/Team/i, "")} Team
                        </h4>
                      </CardHeader>
                      <CardBody>
                        {subTeamData.sub_teams[teamType].map(
                          (teamItem, idx) => {
                            return (
                              <div
                                className="sub-team-body"
                                key={`${new Date()}-${teamType}-${idx}`}
                              >
                                <GridContainer>
                                  <GridItem xs={12} sm={12} md={3}>
                                    <Grid>
                                      <FormControl
                                        variant="outlined"
                                        className={`${classes.formControl} ${
                                          teamItem.isAlreadyPresent
                                            ? classes.disable
                                            : ""
                                        }`}
                                      >
                                        <InputLabel id={"rake-label-" + idx}>
                                          EquipmentList
                                        </InputLabel>
                                        <Select
                                          labelId={"rake-label" + idx}
                                          id={"rake-id" + idx}
                                          name="equipment_id"
                                          value={teamItem.equipment_id || ""}
                                          onChange={(event) => {
                                            handleTeamFieldChange(
                                              event,
                                              teamType,
                                              idx,
                                              "equipment_id"
                                            );
                                          }}
                                          label="EquipmentList"
                                        >
                                          {getSelectableEquipments(
                                            teamType
                                          ).map((equipmentList, idx) => (
                                            <MenuItem
                                              key={idx}
                                              value={equipmentList.id}
                                            >
                                              {equipmentList.product_name} (
                                              {equipmentList.unique_number})
                                            </MenuItem>
                                          ))}
                                        </Select>
                                      </FormControl>
                                    </Grid>
                                  </GridItem>
                                  <GridItem xs={12} sm={12} md={3}>
                                    <Grid>
                                      <FormControl
                                        variant="outlined"
                                        className={`${classes.formControl} ${
                                          teamItem.isAlreadyPresent
                                            ? classes.disable
                                            : ""
                                        }`}
                                      >
                                        <InputLabel id={"vehicle-label" + idx}>
                                          Vehicle
                                        </InputLabel>
                                        <Select
                                          labelId={"vehicle-label" + idx}
                                          id={"vehicle-id" + idx}
                                          onChange={(event) =>
                                            handleTeamFieldChange(
                                              event,
                                              teamType,
                                              idx,
                                              "vehicle_id"
                                            )
                                          }
                                          name="vehicle_id"
                                          label="Vehicle"
                                          value={teamItem.vehicle_id || ""}
                                        >
                                          {getSelectableVehicles(teamType).map(
                                            (vehicle, idx) => (
                                              <MenuItem
                                                key={idx}
                                                value={vehicle.id}
                                              >
                                                {`${vehicle.registration_number} (${vehicle.unique_number})`}
                                              </MenuItem>
                                            )
                                          )}
                                        </Select>
                                      </FormControl>
                                    </Grid>
                                  </GridItem>
                                  <GridItem xs={12} sm={12} md={3}>
                                    <Grid>
                                      <FormControl
                                        variant="outlined"
                                        className={`${classes.formControl} ${
                                          teamItem.isAlreadyPresent
                                            ? classes.disable
                                            : ""
                                        }`}
                                      >
                                        <InputLabel id={"driver-label" + idx}>
                                          Driver
                                        </InputLabel>
                                        <Select
                                          labelId={"driver-label" + idx}
                                          onChange={(event) =>
                                            handleTeamFieldChange(
                                              event,
                                              teamType,
                                              idx,
                                              "driver_id"
                                            )
                                          }
                                          id={"driver-id" + idx}
                                          value={teamItem.driver_id || ""}
                                          name="driver_id"
                                          label="Driver"
                                        >
                                          {getSelectableDrivers(teamType).map(
                                            (driver, idx) => (
                                              <MenuItem
                                                key={idx}
                                                value={driver.id}
                                              >
                                                {driver.name}
                                              </MenuItem>
                                            )
                                          )}
                                        </Select>
                                      </FormControl>
                                    </Grid>
                                  </GridItem>
                                  <GridItem xs={12} sm={12} md={2}>
                                    <Grid>
                                      <FormControl
                                        variant="outlined"
                                        className={`${classes.formControl} ${
                                          teamItem.isAlreadyPresent
                                            ? classes.disable
                                            : ""
                                        }`}
                                      >
                                        <InputLabel id={"helper-label" + idx}>
                                          Helper
                                        </InputLabel>
                                        <Select
                                          labelId={"helper-label" + idx}
                                          onChange={(event) =>
                                            handleTeamFieldChange(
                                              event,
                                              teamType,
                                              idx,
                                              "helper_id"
                                            )
                                          }
                                          value={teamItem.helper_id || ""}
                                          id={"helper-id" + idx}
                                          name="helper_id"
                                          label="Helper"
                                        >
                                          {getSelectableHelpers(teamType).map(
                                            (helper, idx) => (
                                              <MenuItem
                                                key={idx}
                                                value={helper.id}
                                              >
                                                {helper.name}
                                              </MenuItem>
                                            )
                                          )}
                                        </Select>
                                      </FormControl>
                                    </Grid>
                                  </GridItem>
                                  <GridItem xs={12} sm={12} md={1}>
                                    <Grid
                                      container
                                      direction="row"
                                      justify="flex-end"
                                      alignItems="center"
                                    >
                                      <IconButton
                                        edge="end"
                                        aria-label="delete"
                                        onClick={() =>
                                          addOrRemoveTeamItem(
                                            "remove",
                                            idx,
                                            teamType
                                          )
                                        }
                                      >
                                        <RemoveIcon />
                                      </IconButton>
                                      {subTeamData.sub_teams &&
                                        subTeamData.sub_teams[teamType] &&
                                        subTeamData.sub_teams[teamType]
                                          .length ==
                                          idx + 1 && (
                                          <IconButton
                                            edge="end"
                                            aria-label="delete"
                                            onClick={() =>
                                              addOrRemoveTeamItem(
                                                "add",
                                                idx,
                                                teamType
                                              )
                                            }
                                          >
                                            <Icon>add_circle</Icon>
                                          </IconButton>
                                        )}
                                    </Grid>
                                  </GridItem>
                                </GridContainer>
                              </div>
                            );
                          }
                        )}
                      </CardBody>
                    </Card>
                  </GridItem>
                )
              );
            })}

          <GridItem xs={12} sm={12} md={12}>
            <Grid
              container
              direction="row"
              justify="flex-end"
              alignItems="center"
            >
              <Button
                disabled={Boolean(!selectedTeam)}
                color="primary"
                onClick={() => {
                  createSubTeam();
                  setShowPrompt(true);
                }}
              >
                Submit
              </Button>
            </Grid>
          </GridItem>
        </GridContainer>
      </div>
      <Prompt
        when={showPrompt === true}
        message="Are you sure you want to create the sub-team"
      />
    </>
  );
}
